export default __webpack_public_path__ + "static/media/blog-post-img.7bb65d3e.png";